import LoginForm from '../../../components/forms/login/login.form';
import { useAuth } from '../../../hooks/use-auth.hook';
import { AuthDto } from '../../../services/dtos/auth.dto';
import { useState } from 'react';

/**
 * Composant de la page de connexion
 */
export default function LoginPage() {
    let auth = useAuth();
    //Disable ou non le bouton de la validation
    const [validate, setValidate] = useState(false);

    // Comportement au submit du formulaire Login
    const handlerSubmit = async (e: AuthDto) => {
        setValidate(true);
        await auth.signin(e);
        localStorage.removeItem('login');
        setValidate(false);
    };

    return <LoginForm handlerConnectionSubmit={handlerSubmit} validate={validate} />;
}
